import { createReducer } from '@reduxjs/toolkit';
import { setSelections } from '../actions';

const selections = createReducer({},
  (builder) => builder.addCase(setSelections, (state, action) => ({ ...state, ...action.payload }))
);

export default selections;